(() => {
  'use strict';

  const SELECTOR = '[data-pkm-v4-klaviyo-newsletter]';
  const REVISION = '2026-07-15';

  function bind(form) {
    if (form.dataset.pkmV4NewsletterBound === 'true') return;
    form.dataset.pkmV4NewsletterBound = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const email = form.elements.email?.value.trim();
      const button = form.querySelector('button[type="submit"]');
      const fields = form.querySelector('[data-pkm-v4-newsletter-fields]');
      const success = form.querySelector('[data-pkm-v4-newsletter-success]');
      const error = form.querySelector('[data-pkm-v4-newsletter-error]');
      const companyId = form.dataset.klaviyoCompanyId;
      const listId = form.dataset.klaviyoListId;
      const popupFormId = form.dataset.klaviyoFormId;
      if (!email || !companyId || !listId || !popupFormId || !form.reportValidity()) return;

      button.disabled = true;
      error.hidden = true;
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: `Website footer · ${location.hostname}`,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  locale: form.dataset.klaviyoLocale || document.documentElement.lang,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } },
                  },
                  properties: {
                    pkm_signup_surface: 'website_footer',
                    pkm_signup_popup_form_id: popupFormId,
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        },
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: REVISION,
          },
          body: JSON.stringify(payload),
        });
        if (response.status !== 202) throw new Error(`Klaviyo subscription failed: ${response.status}`);
        fields.hidden = true;
        success.hidden = false;
        success.focus({ preventScroll: true });
      } catch (requestError) {
        error.hidden = false;
        button.disabled = false;
        console.error(requestError);
      }
    });
  }

  const bindAll = (root = document) => root.querySelectorAll(SELECTOR).forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
  else bindAll();
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
